// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drfSmgSetting .item_set[data-v-3f569ded] {\n  display: flex;\n  justify-content: space-between;\n}\n.drfSmgSetting[data-v-3f569ded] {\n  width: 95%;\n}\n.drfSmgSetting[data-v-3f569ded]  .el-form-item__content {\n  width: 30rem;\n}\n.drfSmgSetting[data-v-3f569ded]  .el-form-item__content .el-textarea.is-disabled .el-textarea__inner {\n  color: #000;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
